import { createFileRoute } from "@tanstack/react-router";

import ManageCookiesForm from "./-components/ManageCookiesForm";

export const Route = createFileRoute("/_authenticated/settings/cookies")({
  component: ManageCookiesForm,
});
